import API from "../BaseURL";

const configJson = {
  headers: {
    "content-type": "application/json",
  },
};

export async function getAllLicenses() {
  return API.get("/licenses/", configJson);
}

export async function deactivateLicense(hardwareFingerprint) {
  return API.delete(`/licenses/${hardwareFingerprint}`, configJson);
}

export async function reactivateLicense(payload) {
  return API.post("/licenses/reactivate", payload, configJson);
}

export async function deleteLicensePermanently(hardwareFingerprint) {
  return API.delete(`/licenses/${hardwareFingerprint}/permanent`, configJson);
}
